var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5460_2547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.39378 5.96817C9.68787 6.93595 9.94189 7.77173 11.1578 8.41463C12.9191 9.34589 14.3034 8.97108 15.0612 8.59013L20.6137 0H11.0673L8.46045 4.06022C8.98643 4.62947 9.19353 5.30916 9.39378 5.96817Z",
    fill: "#C59C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9423 19.6329C20.7977 20.5092 18.974 20.9164 17.4658 20.9403C15.62 20.9403 14.0202 20.439 12.5792 19.41C11.2821 18.4838 10.2681 17.2677 9.19456 15.9803L9.16339 15.943C7.08978 13.4564 4.45597 11.4367 1.85318 10.3208C1.42953 10.6973 1.09798 11.1863 0.885825 11.7625C0.512934 12.7752 0.547903 13.9296 1.14598 14.9878C2.51543 15.4362 5.63028 16.4559 8.18904 19.8307C11.1302 23.7097 13.4945 23.9999 16.7659 23.9999C20.5367 23.9999 22.986 22.2665 23.3565 21.9145L22.9423 19.6329Z",
    fill: "#C59C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3366 10.4095C12.5082 10.4095 11.551 10.2133 10.5006 9.6579C9.76359 9.26823 9.26845 8.80726 8.91749 8.3252C8.68105 9.99221 8.02434 11.2269 7.41309 12.1914C8.4246 13.0488 9.38076 14.008 10.2434 15.0425L10.2746 15.0799C12.2925 17.4998 14.0347 19.5903 17.607 19.5331C18.5427 19.5182 19.9475 19.3543 22.5892 18.2573C21.9378 16.7544 20.5628 16.5688 19.5149 16.4274C19.0777 16.3683 18.6783 16.3142 18.3493 16.1902H15.2875V14.7839H16.9814C16.6772 14.2756 16.4922 13.7719 16.3835 13.3102H14.3294V11.9039H16.2464C16.2474 11.8776 16.2486 11.8517 16.2499 11.8267C16.2971 10.9544 16.081 10.2931 15.78 9.80176C15.2171 10.0988 14.3789 10.4095 13.3366 10.4095Z",
    fill: "#C59C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30616 11.3103C7.18712 9.89536 7.9997 8.07249 7.39937 5.04736C5.89867 5.45489 4.59658 6.41152 3.6093 7.84013C3.265 8.33832 3.00963 8.82075 2.82812 9.216C4.00516 9.76083 5.17998 10.4705 6.30616 11.3103Z",
    fill: "#C59C37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5460_2547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRun);
export default __webpack_public_path__ + "static/media/run.d7ffd5f2b2bd57a40f8e8f18d5e1c47a.svg";
export { ForwardRef as ReactComponent };